import * as React from 'react';
import { usePageTitle } from '~components/DashboardWrapper/PageTitle';
import { t } from '~/i18n';
import AlertTableContainer from '~/containers/Alerts/AlertTable';

const AlertsPage = () => {
  usePageTitle(t('menu.dashboard.alerts'));
  return <AlertTableContainer />;
};

export default AlertsPage;
